// extracted by mini-css-extract-plugin
export default {"btnVoltar":"ButtonVoltar_btnVoltar__I5n0i","icon":"ButtonVoltar_icon__SeS9D"};